export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '6.0.6'
};
